export default __webpack_public_path__ + "static/media/rent-first-top.5ec1578e.jpg";